/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    ApiAlertType,
    ApiAlertTypeFromJSON,
    ApiAlertTypeToJSON,
    ApiFilteredAlerts,
    ApiFilteredAlertsFromJSON,
    ApiFilteredAlertsToJSON,
    ApiSortDirection,
    ApiSortDirectionFromJSON,
    ApiSortDirectionToJSON,
} from '../models';

export interface FindAlertFilterResultsRequest {
    filterId: number;
    direction: ApiSortDirection;
    orderBy: FindAlertFilterResultsOrderByEnum;
    size: number;
    offsetTime?: Date;
    currentId?: number;
    currentType?: ApiAlertType;
}

/**
 * 
 */
export class AlertFilterResultApi extends runtime.BaseAPI {

    /**
     */
    async findAlertFilterResultsRaw(requestParameters: FindAlertFilterResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiFilteredAlerts>> {
        if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
            throw new runtime.RequiredError('filterId','Required parameter requestParameters.filterId was null or undefined when calling findAlertFilterResults.');
        }

        if (requestParameters.direction === null || requestParameters.direction === undefined) {
            throw new runtime.RequiredError('direction','Required parameter requestParameters.direction was null or undefined when calling findAlertFilterResults.');
        }

        if (requestParameters.orderBy === null || requestParameters.orderBy === undefined) {
            throw new runtime.RequiredError('orderBy','Required parameter requestParameters.orderBy was null or undefined when calling findAlertFilterResults.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAlertFilterResults.');
        }

        const queryParameters: any = {};

        if (requestParameters.direction !== undefined) {
            queryParameters['direction'] = requestParameters.direction;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['orderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.offsetTime !== undefined) {
            queryParameters['offsetTime'] = (requestParameters.offsetTime as any).toISOString();
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.currentId !== undefined) {
            queryParameters['currentId'] = requestParameters.currentId;
        }

        if (requestParameters.currentType !== undefined) {
            queryParameters['currentType'] = requestParameters.currentType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v2/alerts/filters/{filterId}/results`.replace(`{${"filterId"}}`, encodeURIComponent(String(requestParameters.filterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiFilteredAlertsFromJSON(jsonValue));
    }

    /**
     */
    async findAlertFilterResults(requestParameters: FindAlertFilterResultsRequest, initOverrides?: RequestInit): Promise<ApiFilteredAlerts> {
        const response = await this.findAlertFilterResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum FindAlertFilterResultsOrderByEnum {
    CREATED_TIME = 'CREATED_TIME',
    STATUS_UPDATED_TIME = 'STATUS_UPDATED_TIME'
}
